module.exports = __webpack_public_path__ + "static/media/g5.1c61514d.jpg";